import { render, staticRenderFns } from "./CustomersTable.vue?vue&type=template&id=bc62364e"
import script from "./CustomersTable.vue?vue&type=script&lang=js"
export * from "./CustomersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports